import { pageJump } from '@/hooks/useJump';
const pageJump_ = pageJump();
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import {projectName} from "@/utils/config";
export default [
  {
    path: '/IFPageEightyEightPreLogin',
    name: 'PageEightyEightPreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageEightyEight/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (from.path === '/IFPageEightyEightLogin') {
        pageJump_.jump();
      }
      next();
    },
  },
  {
    path: '/IFPageEightyEightLogin',
    name: 'PageEightyEightLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageEightyEight/login.vue'),
  },
  {
    path: '/IFPageEightyEightLeaveInfo',
    name: 'PageEightyEightLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageEightyEight/leaveInfo.vue'),
  },
  {
    path: '/IFPageEightyEightResult',
    name: 'PageEightyEightResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageEightyEight/result.vue'),
  },
  {
    path: '/IFPageEightyEightLoading',
    name: 'PageEightyEightLoading',
    component: () => import('@/pages/pageListAll/pageEightyEight/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageEightyEightCar',
    name: 'pageEightyEightCar',
    component: () => import('@/pages/pageListAll/pageEightyEight/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageEightyEightBlank',
    name: 'pageEightyEightBlank',
    component: () => import('@/pages/pageListAll/pageEightyEight/blank.vue'),
    meta: {
      title: projectName,
    },
  },
];
